<template>
  <div>
    <Dropdown
      class="dropdown-with-buttons"
      :visible="isDropdownVisible"
      :placement="placement"
      :trigger="trigger"
      :disabled="dropdownDisabled"
      @visibleChange="handleVisibleChange"
    >
      <slot />
      <!-- В ant 3.2.9 у Dropdown есть баг (или фича) связанный с тем,
           что в <template #overlay> должен содержаться только один элемент,
           при этом за элемент считается даже комментарии -->
      <template #overlay>
        <div
          class="dropdown-with-buttons__content"
          :class="dropdownContentClass"
        >
          <!-- TODO вынести в отдельный переиспользуемый компонент content + кнопки -->
          <slot name="content" />

          <div :class="actionClasses">
            <Button
              class="dropdown-with-buttons__button"
              :size="ESize.small"
              :title="tt('shared.action.cancel')"
              @click="handleCancelClick"
            />

            <Button
              :type="EButtonType.primary"
              :disabled="disabled"
              :size="ESize.small"
              :title="saveButtonText"
              @click="handleSaveClick"
            >
              {{ saveButtonText }}
            </Button>
          </div>
        </div>
      </template>
    </Dropdown>
  </div>
</template>

<script lang="ts">
import { Dropdown } from 'ant-design-vue';
import {
  defineComponent,
  ref,
  watch,
  PropType,
  computed,
} from 'vue';

import tt from '@/i18n/utils/translateText';
import { Button } from '@/ui';
import { EButtonType, ESize } from '@/ui/types';

export default defineComponent({
  name: 'DropdownWithButtons',
  components: {
    Dropdown,
    Button,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dropdownDisabled: {
      type: Boolean,
      default: false,
    },
    placement: {
      type: String as PropType<'bottomLeft' | 'bottomCenter' | 'bottomRight' | 'topLeft' | 'topCenter' | 'topRight'>,
      default: 'bottomLeft',
    },
    trigger: {
      type: String as PropType<'click' | 'hover' | 'contextmenu'>,
      default: 'hover',
    },
    saveButtonText: {
      type: String,
      default: tt('shared.action.save'),
    },
    placementAction: {
      type: String as PropType<'left' | 'right'>,
      default: 'left',
    },
    dropdownContentClass: {
      type: [String, null] as PropType<string | null>,
      default: null,
    },
  },
  emits: [
    'cancel',
    'changeVisible',
    'close',
    'save',
  ],
  setup(props, { emit, expose }) {
    const isDropdownVisible = ref(props.visible);

    const actionClasses = computed(() => {
      let classes = 'dropdown-with-buttons__row';
      if (props.placementAction === 'right') {
        classes += ' dropdown-with-buttons__row_right_align';
      }
      return classes;
    });

    const dropdownClose = () => {
      isDropdownVisible.value = false;
    };

    const handleSaveClick = () => {
      emit('save');
    };

    const handleCancelClick = () => {
      emit('cancel');
      dropdownClose();
      emit('changeVisible', false);
    };

    const handleVisibleChange = (isVisible: boolean) => {
      isDropdownVisible.value = isVisible;
      emit('changeVisible', isVisible);
    };

    watch(() => props.visible, (isVisible: boolean) => {
      handleVisibleChange(isVisible);
    });

    expose({ dropdownClose });

    return {
      EButtonType,
      ESize,
      isDropdownVisible,
      actionClasses,

      handleSaveClick,
      handleCancelClick,
      handleVisibleChange,
      dropdownClose,
      tt,
    };
  },
});
</script>

<style lang="scss" src="./styles.scss" />
